import { Pipe } from '@angular/core';
import { createRound, isString } from '../utils/utils';
var FloorPipe = (function () {
    function FloorPipe() {
    }
    FloorPipe.prototype.transform = function (value, precision) {
        if (precision === void 0) { precision = 0; }
        if (isString(precision)) {
            precision = parseInt(precision);
        }
        return createRound('floor')(value, precision);
    };
    return FloorPipe;
}());
export { FloorPipe };
FloorPipe.decorators = [
    { type: Pipe, args: [{
                name: 'floor'
            },] },
];
/** @nocollapse */
FloorPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=floor.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/math/floor.pipe.js
// module id = 262
// module chunks = 103